import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./CarouselCustom.css"; // Ensure you're importing your CSS

const CarouselCustom = () => {
  return (
    <div className="image-carousel">
      <Carousel
        showThumbs={false}
        autoPlay={true}
        infiniteLoop={true}
        showStatus={false}
        interval={3000} // This sets the interval to 3 seconds
      >
        <div>
          <img src="/shooting-maria/picture2.jpeg" alt="Picture 1" />
        </div>
        <div>
          <img src="/shooting-maria/picture1.jpeg" alt="Picture 2" />
        </div>
        <div>
          <img src="/shooting-maria/picture3.jpg" alt="Picture 3" />
        </div>
      </Carousel>
    </div>
  );
};

export default CarouselCustom;
